/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import type { TargettedEvent } from '@suntex.core/animation';
import { LoadUtil, TestUtil, UIUtil } from '@suntex.core/animation';
import {
  Entities_Player_PlayerMeta_Response,
  Entities_Player_UpdateMeta_Request,
  PlayerId,
} from '@suntex.fim/api-client';
import { ArithmeticOperation } from '@suntex.fim/enums';
import { showErrorMessage } from '@suntex.fim/ui';
import { ValueText } from '@suntex.modules/core';

import { playFrame } from './compat';
import {
  GEARS_EQS_ADD,
  GEARS_EQS_MUL,
  GEARS_EQS_MULDIV_EXT,
} from './data/vifGearsData';
import { chartCell } from './engine/grid';
import type {
  GearsGameStage,
  VifCongratulations,
  VifGameProgArgs,
  VifGear,
  VifGearsChart,
  VifGearsChartIndex,
  VifMidGear,
} from './types';

export function VIFGears_prog({
  api,
  exportRoot,
  params,
  onComplete,
}: VifGameProgArgs) {
  let gameStage: GearsGameStage;
  const TEST = false;

  // Game Data
  let gameFlag = 0;
  let vifStage = 1;
  let playerId: PlayerId = 0 as PlayerId;
  let metaKey = '';
  let startingGearPosition = 0;

  let intBlinks = 0;
  let intCorrect = 0;
  let scoreMax = 16;
  let offset = 0;
  let gearA: VifGear;
  let gearB: VifGear;
  let gearC: VifGear;
  let gearMID: VifMidGear;
  let equationCurtain: createjs.MovieClip;
  let equationCurtainX: number;
  let arrowA: createjs.MovieClip;
  let arrowB: createjs.MovieClip;
  let arrowC: createjs.MovieClip;
  let arrowD: createjs.MovieClip;
  let plusMulChar = '';
  let minusDivChar = '';
  let gearRolling = false;
  let currentPanel: createjs.MovieClip;
  let allEQs = GEARS_EQS_ADD;
  const pnls: createjs.MovieClip[][] = [[], []];
  let intCurrEq = -1;
  let currentArrow: createjs.MovieClip;
  let startX = 0;
  let startY = 0;
  let endX = 0;
  let endY = 0;
  let currentGear: createjs.MovieClip;
  let currentGearName = '';
  let gearRolled = [0, 0, 0, 0];
  let eqVals = [2, 3, 5];
  let gridItems: number;
  let operation: number;
  let preview = false;
  let pwaMode = false;
  let veil: createjs.DisplayObject;
  let congratulations: VifCongratulations;

  function run() {
    gameStage = exportRoot.gameStage as GearsGameStage;
    veil = exportRoot.veil;
    congratulations = exportRoot.congratulations;

    VIFGears();
  }

  function VIFGears() {
    UIUtil.createSimpleToggleButton(gameStage.musicBtn, toggleMusic);
    UIUtil.createSimpleToggleButton(gameStage.muteBtn, toggleSound);

    preview = params.preview ?? false;

    if (TEST) {
      //mute();
      startingGearPosition = 12;
    } else {
      pwaMode = params.pwaMode ?? false;
      playerId = params.playerId;
      vifStage = params.stage;
      gameFlag = params.moduleVariant;
    }

    gearA = gameStage.gearA;
    gearB = gameStage.gearB;
    gearC = gameStage.gearC;
    //UIUtil.hide(gearC);
    gearMID = gameStage.gearMID;
    arrowA = gameStage.arrowA;
    UIUtil.tween(arrowA, 'alpha', 0.4, 0);
    arrowB = gameStage.arrowB;
    UIUtil.tween(arrowB, 'alpha', 0.4, 0);
    arrowC = gameStage.arrowC1;
    UIUtil.tween(arrowC, 'alpha', 0.4, 0);
    arrowD = gameStage.arrowD;
    UIUtil.tween(arrowD, 'alpha', 0.4, 0);
    let schart: VifGearsChart | undefined;
    let moveSubChart: createjs.MovieClip | undefined;
    //var zzz = 9;
    let achart: VifGearsChart | undefined;
    let moveAddChart: createjs.MovieClip | undefined;
    let a: createjs.MovieClip[] = [];
    pnls.length = 0;

    equationCurtain = gearMID.cSlide;
    equationCurtainX = equationCurtain.x;

    switch (gameFlag) {
      case 0:
        achart = gameStage.addChart;
        schart = gameStage.subtractChart;
        moveSubChart = gameStage.divideChart;
        moveAddChart = gameStage.multiplyChart;
        plusMulChar = ' + ';
        minusDivChar = ' - ';
        gridItems = 16;
        scoreMax = 16;
        allEQs = GEARS_EQS_ADD;
        //eqChosen = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        metaKey = 'gear-sub-progress';
        operation = ArithmeticOperation.Subtraction;
        break;
      case 1:
        //achart = gameStage.addChart;
        achart = gameStage.multiplyChart;
        moveAddChart = gameStage.addChart;
        schart = gameStage.divideChart;
        moveSubChart = gameStage.subtractChart;
        plusMulChar = ' × ';
        minusDivChar = ' ÷ ';
        gridItems = 36;
        scoreMax = 21;
        allEQs = GEARS_EQS_MUL;
        //eqChosen = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        metaKey = 'gear-div-progress';
        operation = ArithmeticOperation.Division;
        break;
      case 2:
        //achart = gameStage.addChart;
        achart = gameStage.multiplyChart;
        moveAddChart = gameStage.addChart;
        schart = gameStage.divideChart;
        moveSubChart = gameStage.subtractChart;
        plusMulChar = ' × ';
        minusDivChar = ' ÷ ';
        gridItems = 36;
        scoreMax = 36;
        offset = 21;
        allEQs = GEARS_EQS_MULDIV_EXT;
        //eqChosen = [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        metaKey = 'gear-div-progress-1';
        operation = ArithmeticOperation.Division;
        break;

      default:
        break;
    }
    UIUtil.moveTo(moveAddChart!, -1500, -1500, 0);
    UIUtil.moveTo(moveSubChart!, -1500, -1500, 0);
    for (let b = 0; b <= gridItems - 1; b++) {
      a = [];
      a.push(chartCell(achart!, 'a', b as VifGearsChartIndex)!);
      a.push(chartCell(schart!, 's', b as VifGearsChartIndex)!);
      pnls.push(a);
    }
    UIUtil.hide(gameStage);
    initInterface();

    if (!preview) {
      loadVars(onVarsLoad);
    } else {
      UIUtil.delay(onNoLoad, 500);
    }
  }

  function onVarsLoad(vars: Entities_Player_PlayerMeta_Response) {
    startGame();

    startingGearPosition = vars['intValue'];
    //startingGearPosition = 11;
    if (gameFlag == 2 && startingGearPosition < offset) {
      startingGearPosition = offset;
    }

    intCorrect = startingGearPosition;
    if (intCorrect < scoreMax) {
      setPositionAndStartGame(startingGearPosition);
    } else {
      //Bob says let replays happen.

      preview = true;
      startingGearPosition = 0;

      if (gameFlag == 2 && startingGearPosition < offset) {
        startingGearPosition = offset;
      }

      intCorrect = startingGearPosition;

      setPositionAndStartGame(startingGearPosition);
    }
  }

  function onNoLoad() {
    startGame();

    startingGearPosition = 0;

    if (gameFlag == 2 && startingGearPosition < offset) {
      startingGearPosition = offset;
    }

    intCorrect = startingGearPosition;
    if (intCorrect < scoreMax) {
      setPositionAndStartGame(startingGearPosition);
    } else {
      gameOver();
    }
  }

  function loadVars(
    onLoad: (vars: Entities_Player_PlayerMeta_Response) => void,
  ) {
    if (pwaMode) {
      TestUtil.log('isPWAMode');
    }

    void api
      .get_Player_PlayerMeta2({ playerId, metaKey })
      .then((values) => onLoad(values))
      .catch((e) => showErrorMessage('Failed to load VIF progress.', e));
  }

  function setPositionAndStartGame(iTilesFinished: number) {
    for (let i = 0; i < iTilesFinished; i++) {
      UIUtil.setFrame(pnls[i]![0], 2);
      UIUtil.setFrame(pnls[i]![1], 2);
    }
    intCurrEq = iTilesFinished - 1;

    nextProblem();
  }

  function continueVIF() {
    if (typeof onComplete === 'function') {
      onComplete(playerId, operation, vifStage);
    } else {
      TestUtil.log('videoComplete function not found on window');
    }
  }

  function startGame() {
    loadSounds();
    UIUtil.hide(veil);

    UIUtil.hide(congratulations);

    UIUtil.show(gameStage, 500);
    UIUtil.setFrame(gameStage.gameMeter, 1);
  }

  /* Sounds */
  function loadSounds() {
    //Originally Bob wanted these all different
    if (gameFlag == 0) {
      setBackgroundLoop('gears-1.mp3');
    } else if (gameFlag == 1) {
      setBackgroundLoop('gears.mp3');
    } else {
      setBackgroundLoop('gears.mp3');
    }

    loadSound('ding3.mp3', 'ding');
    loadSound('rotate.mp3', 'rotate');
  }

  function setBackgroundLoop(src: string) {
    //TODO: Revisit how to load sound files based on local vs hosted protype vs site integrated vs working offline like in a PWA.
    LoadUtil.startLoop((params.soundDirectory ?? '/sounds/') + 'loops/' + src);
  }

  function loadSound(src: string, id: string) {
    //TODO: Revisit how to load sound files based on local vs hosted protype vs site integrated vs working offline like in a PWA.
    LoadUtil.loadSound((params.soundDirectory ?? '/sounds/') + src, id);
  }

  function toggleSound(soundOn: boolean) {
    if (soundOn) {
      LoadUtil.unmute();
    } else {
      LoadUtil.mute();
    }
  }

  function toggleMusic(musicOn: boolean) {
    if (musicOn) LoadUtil.restartLoop();
    else LoadUtil.stopLoop();
  }

  /* Interface */

  function initInterface() {
    //UIUtil.createButton(gameStage.startButton, activateStartButton, false, null, null);
    initButtons();
  }

  function initButtons() {
    UIUtil.createButton(
      gearA,
      gearNull,
      'gearA',
      buttonMouseOver,
      buttonMouseOut,
    );
    UIUtil.onMouseDownAndUp(gearA, gearMouseDown, gearMouseUp);
    UIUtil.createButton(
      gearB,
      gearNull,
      'gearB',
      buttonMouseOver,
      buttonMouseOut,
    );
    UIUtil.onMouseDownAndUp(gearB, gearMouseDown, gearMouseUp);
    UIUtil.createButton(
      gearC,
      gearNull,
      'gearC',
      buttonMouseOver,
      buttonMouseOut,
    );
    UIUtil.onMouseDownAndUp(gearC, gearMouseDown, gearMouseUp);
    gearA.mouseChildren = false;
    gearB.mouseChildren = false;
    gearC.mouseChildren = false;
  }

  function gameOver() {
    UIUtil.delay(promptCongratulations, 500);
  }

  /**** Congratulations ****/
  function promptCongratulations() {
    UIUtil.show(congratulations, 500);
    UIUtil.createButton(congratulations.btn, continueVIF, 0);
  }

  function buttonMouseOver(e: object) {
    if (gearRolling == false) {
      const btn = UIUtil.getEventTarget<{ value: string }>(
        e as TargettedEvent<{ value: string }>,
      );
      UIUtil.setFrame(btn, 2);
      if (btn.value.substr(4, 1) == 'C') {
        let d = (e as createjs.MouseEvent).target.righta as createjs.MovieClip;
        if (gearRolled[2] == 1) {
          UIUtil.hide(d, 0, undefined);
        } else {
          UIUtil.show(d, 0, undefined);
        }
        d = (e as createjs.MouseEvent).target.lefta;
        if (gearRolled[3] == 1) {
          UIUtil.hide(d, 0, undefined);
        } else {
          UIUtil.show(d, 0, undefined);
        }
      }
    }
  }

  function updateDB() {
    const vars = {} as Entities_Player_UpdateMeta_Request;

    vars.playerId = playerId;
    vars.metaKey = metaKey;
    vars.intValue = intCorrect;
    vars.textValue = '';

    //get the salt and then call the method with that name
    //note: here using the obscure fact that window.saltvalue has been
    //preloaded with the magic hash function
    const salt = window.salter();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any
    (window as any)[salt](vars);

    if (TEST) {
      //TestUtil.log( "updateDB()::" + vars );
    } else {
      if (pwaMode && !preview) {
        TestUtil.log('isPWAMode');
      }
      void api.post_Player_UpdateMeta(vars);
    }
  }

  function buttonMouseOut(e: object) {
    if (gearRolling == false) {
      const btn = UIUtil.getEventTarget(e as TargettedEvent<unknown>);
      UIUtil.setFrame(btn, 1);
    }
  }

  function nextProblem() {
    intCurrEq++;
    ValueText.displayText(gearA.t.textb, allEQs[intCurrEq]![0], 0);
    ValueText.displayText(gearB.t.textb, allEQs[intCurrEq]![1], 0);
    ValueText.displayText(gearC.t.textb, allEQs[intCurrEq]![2], 1);
    UIUtil.tween(gearMID.ta.textb, 'alpha', 0, 0);
    gearRolled = [0, 0, 0, 0];
    eqVals = allEQs[intCurrEq]!;
    UIUtil.enable(gearA);
    UIUtil.enable(gearB);
    UIUtil.enable(gearC);
  }

  function getMouseCoordinates(e: createjs.MouseEvent) {
    const point = UIUtil.getMousePosition(e); //removed draggingPiece (does nothing)
    const coord = {
      row: Math.floor(point.y / 145),
      col: Math.floor(point.x / 135),
    };
    //var coord = {row: point.y, col: point.x};
    return coord;
  }

  function gearNull(_e: object) {}

  function gearMouseDown(e: createjs.MouseEvent) {
    if (!gearRolling) {
      const p = UIUtil.getEventTarget<{ value: string }>(e);
      const g = p.value.substr(4, 1);
      if (g == 'A') {
        UIUtil.onMouseOut(p, gearAMouseOut);
      } else if (g == 'B') {
        UIUtil.onMouseOut(p, gearBMouseOut);
      } else if (g == 'C') {
        UIUtil.onMouseOut(p, gearCMouseOut);
      }
      const coord = UIUtil.getMousePosition(e);
      startX = coord.x;
      startY = coord.y;
    }
  }

  function gearMouseUp(e: createjs.MouseEvent) {
    if (startX != -1000 && !gearRolling) {
      const p = UIUtil.getEventTarget<{ value: string }>(e);
      const g = p.value.substr(4, 1);
      const coord = UIUtil.getMousePosition(e);
      endX = coord.x;
      endY = coord.y;
      if (g == 'A') {
        if (endX > startX && endY < startY) {
          currentGear = gearA;
          currentGearName = 'A';
          gearRolled[0] = 1;
          rollGear(gearA, arrowA);
        }
      } else if (g == 'B') {
        if (endX < startX && endY < startY) {
          currentGear = gearB;
          currentGearName = 'B';
          gearRolled[1] = 1;
          rollGear(gearB, arrowB);
        }
      } else if (g == 'C') {
        if (endX > startX && endY < startY && gearRolled[2] == 0) {
          currentGear = gearC;
          currentGearName = 'C';
          gearRolled[2] = 1;
          rollGear(gearC, arrowC);
        } else if (endX < startX && endY < startY && gearRolled[3] == 0) {
          currentGear = gearC;
          currentGearName = 'D';
          gearRolled[3] = 1;
          rollGear(gearC, arrowD);
        }
      }
      startX = -1000;
      startY = -1000;
    }
  }

  function gearAMouseOut(e: object) {
    if (startX != -1000 && !gearRolling) {
      UIUtil.onMouseOut(
        UIUtil.getEventTarget(e as TargettedEvent<unknown>),
        gearNull,
      );
      const coord = UIUtil.getMousePosition(e as createjs.MouseEvent);
      endX = coord.x;
      endY = coord.y;
      if (endX > startX && endY < startY) {
        currentGear = gearA;
        currentGearName = 'A';
        rollGear(gearA, arrowA);
        gearRolled[0] = 1;
      }
      startX = -1000;
      startY = -1000;
    }
  }

  function gearBMouseOut(e: object) {
    if (startX != -1000 && !gearRolling) {
      UIUtil.onMouseOut(
        UIUtil.getEventTarget(e as TargettedEvent<unknown>),
        gearNull,
      );
      const coord = UIUtil.getMousePosition(e as createjs.MouseEvent);
      endX = coord.x;
      endY = coord.y;
      if (endX < startX && endY < startY) {
        currentGear = gearB;
        currentGearName = 'B';
        rollGear(gearB, arrowB);
        gearRolled[1] = 1;
      }
      startX = -1000;
      startY = -1000;
    }
  }

  function gearCMouseOut(e: object) {
    if (startX != -1000 && !gearRolling) {
      UIUtil.onMouseOut(
        UIUtil.getEventTarget(e as TargettedEvent<unknown>),
        gearNull,
      );
      const coord = UIUtil.getMousePosition(e as createjs.MouseEvent);
      endX = coord.x;
      endY = coord.y;
      if (endX > startX && endY < startY && gearRolled[2] == 0) {
        currentGear = gearC;
        currentGearName = 'C';
        rollGear(gearC, arrowC);
        gearRolled[2] = 1;
      } else if (endX < startX && endY < startY && gearRolled[3] == 0) {
        currentGear = gearC;
        currentGearName = 'D';
        rollGear(gearC, arrowD);
        gearRolled[3] = 1;
      }
      startX = -1000;
      startY = -1000;
    }
  }

  function rollGear(g: createjs.MovieClip, a: createjs.MovieClip) {
    if (!gearRolling) {
      LoadUtil.playSound('rotate');

      if (currentGearName == 'A') {
        ValueText.displayText(
          gearMID.ta.textb,
          eqVals[0]!.toString() +
            plusMulChar +
            eqVals[1]!.toString() +
            ' = ' +
            eqVals[2]!.toString(),
          3,
        );
      } else if (currentGearName == 'B') {
        ValueText.displayText(
          gearMID.ta.textb,
          eqVals[1]!.toString() +
            plusMulChar +
            eqVals[0]!.toString() +
            ' = ' +
            eqVals[2]!.toString(),
          3,
        );
      } else if (currentGearName == 'C') {
        ValueText.displayText(
          gearMID.ta.textb,
          eqVals[2]!.toString() +
            minusDivChar +
            eqVals[1]!.toString() +
            ' = ' +
            eqVals[0]!.toString(),
          3,
        );
      } else {
        ValueText.displayText(
          gearMID.ta.textb,
          eqVals[2]!.toString() +
            minusDivChar +
            eqVals[0]!.toString() +
            ' = ' +
            eqVals[1]!.toString(),
          3,
        );
      }
      gearRolling = true;
      UIUtil.disable(g);
      if (currentGearName == 'D') {
        playFrame(g, 82);
      } else {
        playFrame(g, 3);
      }
      currentArrow = a;
      //UIUtil.setInterval(moveArrows, 65);
      playFrame(currentArrow, 2);
      UIUtil.setInterval(arrowOver, 2000);
      //gearMID.ta.textb.displayText('2 + 3 = 5',3);
      UIUtil.tween(equationCurtain, 'x', 900, 3600);
      UIUtil.tween(gearMID.ta.textb, 'alpha', 10, 1000);
    }
  }

  function arrowOver() {
    UIUtil.clearInterval(arrowOver);
    if (currentGearName == 'D') {
      playFrame(currentGear, 122);
    } else {
      playFrame(currentGear, 42);
    }
    if (
      (currentGearName == 'A' || currentGearName == 'B') &&
      gearRolled[0] == 1 &&
      gearRolled[1] == 1
    ) {
      currentPanel = pnls[intCurrEq]![0]!;
      intBlinks = 0;
      blinkPanel();
    } else if (
      (currentGearName == 'C' || currentGearName == 'D') &&
      gearRolled[2] == 1 &&
      gearRolled[3] == 1
    ) {
      currentPanel = pnls[intCurrEq]![1]!;
      intBlinks = 0;
      blinkPanel();
    }
    UIUtil.setInterval(gearOver, 1500);
    UIUtil.setFrame(currentArrow, 1);
  }

  function gearOver() {
    //TestUtil.log("gearOver");
    UIUtil.clearInterval(gearOver);
    //UIUtil.tween(gearMID.ta.textb,"alpha",0,0,'',null,null);
    returnCurtain();
    gearRolling = false;

    if (
      (currentGearName == 'C' || currentGearName == 'D') &&
      (gearRolled[2] == 0 || gearRolled[3] == 0)
    ) {
      UIUtil.enable(gearC);
    } else if (
      gearRolled[0] == 1 &&
      gearRolled[1] == 1 &&
      gearRolled[2] == 1 &&
      gearRolled[3] == 1
    ) {
      checkForEnd();
    }

    //currentGear = null;
    currentGearName = '';
  }

  function blinkPanel() {
    if (gearRolled[0] == 0) {
      UIUtil.disable(gearA);
    }
    if (gearRolled[1] == 0) {
      UIUtil.disable(gearB);
    }
    if (gearRolled[2] == 0 && gearRolled[3] == 0) {
      UIUtil.disable(gearC);
    }
    UIUtil.delay(blinkCurrentPanel, 20);
  }

  function blinkCurrentPanel() {
    if (intBlinks == 0) {
      LoadUtil.playSound('ding');
      //intStep = 3;

      if (gearRolled[0] == 0) {
        UIUtil.enable(gearA);
      }
      if (gearRolled[1] == 0) {
        UIUtil.enable(gearB);
      }
      if (gearRolled[2] == 0 && gearRolled[3] == 0) {
        UIUtil.enable(gearC);
      }
      const cf = UIUtil.getCurrentFrame(currentPanel);
      if (cf == 1) {
        UIUtil.setFrame(currentPanel, 2);
      } else {
        UIUtil.setFrame(currentPanel, 1);
      }
      //intBlinks++;
    } else {
      //intStep = 3;

      if (gearRolled[0] == 0) {
        UIUtil.enable(gearA);
      }
      if (gearRolled[1] == 0) {
        UIUtil.enable(gearB);
      }
      if (gearRolled[2] == 0 && gearRolled[3] == 0) {
        UIUtil.enable(gearC);
      }

      //UIUtil.createButton(gearC,gearCClicked, null, buttonMouseOver, buttonMouseOut);
    }
  }

  function checkForEnd() {
    intCorrect++;

    if (!preview) {
      updateDB();
    }

    if (intCorrect < scoreMax) {
      nextProblem();
    } else {
      gameOver();
    }
  }

  function returnCurtain() {
    UIUtil.tween(equationCurtain, 'x', equationCurtainX, 0);
    //UIUtil.tween(equationCurtain,"width",equationCurtainWidth,0,null,null,null);
  }

  run();
}
